import { get } from 'lodash-es';
import { getMenus, getUserInfo } from '../services';
import { getEnvMAP } from './constant';
import { NODE_ENV } from './env';
import { request } from '../io/request';
export const fetchGlobalMsg = (systemId) => {
    return Promise.all([getMenus(systemId), getUserInfo(systemId)])
        .then(([menus, _userinfo]) => {
        let globalData = {
            resourceList: [],
            systemId: '',
            userinfoFromApiAll: null,
            systemName: '',
            permissionList: [],
            userInfoFromSession: null,
            iconPath: '',
        };
        if (menus) {
            const { data, code } = menus;
            if (code === 200) {
                const { resourceList, iconPath, systemPath } = data || {};
                globalData.resourceList = resourceList ?? [];
                globalData.iconPath = iconPath;
            }
        }
        const userInfoFromSession = JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
        if (_userinfo) {
            const systemId = get(_userinfo, 'data.systemId', '');
            const systemName = get(_userinfo, 'data.systemName', '');
            const permissionList = get(_userinfo, 'data.permissions[0].actionEntitySet', []);
            globalData = {
                ...globalData,
                userinfoFromApiAll: _userinfo,
                systemId,
                systemName,
                permissionList,
                userInfoFromSession,
            };
        }
        return Promise.resolve(globalData);
    })
        .catch((err) => {
        throw new Error(err);
    });
};
export function setMobileSession() {
    const searchParams = new URLSearchParams(window.location.search);
    const ACCESS_TOKEN = searchParams.get('ACCESS_TOKEN') || '';
    const fp = searchParams.get('fp') || '';
    const ct = searchParams.get('ct') || '';
    const pt = searchParams.get('pt') || '';
    if (ACCESS_TOKEN) {
        sessionStorage.setItem('ACCESS_TOKEN', ACCESS_TOKEN);
    }
    if (ct) {
        sessionStorage.setItem('ct', ct);
    }
    if (pt) {
        sessionStorage.setItem('pt', pt);
    }
    if (fp) {
        localStorage.setItem('fp', fp);
    }
}
/**
 * 根据域名判断
 */
// export const systensNames = Object.keys(ENV_MAP);
export function getSystemName(authLoginType) {
    const ENV_MAP = getEnvMAP();
    const systensNames = Object.keys(ENV_MAP);
    if (NODE_ENV === 'development') {
        return {
            enName: authLoginType,
            cnName: authLoginType ? ENV_MAP[authLoginType].name : '',
        };
    }
    const hostname = window.location.hostname;
    // 可信工程要排最后  例：xxx.kxgc 会出现这种情况
    // 自己的平台判断
    for (let i = systensNames.length - 1; i >= 0; i--) {
        const name = systensNames[i];
        if (hostname.includes(name.toLocaleLowerCase())) {
            return {
                enName: name,
                cnName: ENV_MAP[name].name,
            };
        }
    }
    // 兼容自定义平台
    return {
        enName: authLoginType || '',
        // @ts-ignore
        cnName: window?.systemNameMap
            ? // @ts-ignore
                window.systemNameMap[authLoginType] ?? ''
            : '',
    };
}
export const clearBackPageCache = () => { };
export const closeCurrentAndBack = () => { };
/**
 * 跳转到其他平台
 */
export const jumpExternalSystem = async (origin, pathname) => {
    request('/api/common-center/v1/sm2/login-param', {
        method: 'GET',
        headers: {
            'system-id': '1',
        },
    }).then((res) => {
        const { code, data } = res || {};
        if (code === 200) {
            const fp = localStorage.getItem('fp') || '';
            const url = `${origin}/common/external?redirectUrl=
      ${encodeURIComponent(origin + pathname)}&encryptStr=${encodeURIComponent(data)}&fp=${encodeURIComponent(fp)}
      `;
            window.open(url);
        }
    });
};
export function getUrlParams(url) {
    let urlStr = url.split('?')[1];
    let obj = {};
    if (urlStr) {
        let paramsArr = urlStr.split('&');
        for (let i = 0, len = paramsArr.length; i < len; i++) {
            let arr = paramsArr[i].split('=');
            obj[arr[0]] = arr[1];
        }
    }
    return obj;
}
